import { render, staticRenderFns } from "./toggle-column.vue?vue&type=template&id=61bd9ac8"
import script from "./toggle-column.vue?vue&type=script&lang=js"
export * from "./toggle-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61bd9ac8')) {
      api.createRecord('61bd9ac8', component.options)
    } else {
      api.reload('61bd9ac8', component.options)
    }
    module.hot.accept("./toggle-column.vue?vue&type=template&id=61bd9ac8", function () {
      api.rerender('61bd9ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outgoing-number/users/toggle-column.vue"
export default component.exports